import { useState } from 'react';
import api from '../lib/api';
import { useAuth } from '../hooks/useAuth';

export default function BulkKDPage() {
  const [keywords, setKeywords] = useState('');
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const { updateCredits } = useAuth();

  async function analyze() {
    const list = keywords.split('\n').map(k => k.trim()).filter(Boolean);
    if (list.length === 0) { setError('Enter at least 1 keyword'); return; }
    if (list.length > 100) { setError('Max 100 keywords'); return; }
    setError(''); setLoading(true); setData(null);
    try {
      const res = await api.post('/keywords/difficulty', { keywords: list });
      setData(res.data.data);
      updateCredits(res.data.credits_remaining);
    } catch (e) { setError(e.response?.data?.error || 'Failed'); } finally { setLoading(false); }
  }

  return (
    <div className="fade-up">
      <div className="page-header">
        <h1 className="page-title">Bulk Keyword Difficulty</h1>
        <p className="page-sub">Check KD, volume, CPC for up to 100 keywords at once · 2 credits</p>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 10 }}>
          <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: '#6B7280', marginBottom: 6 }}>Keywords (one per line, max 100)</div>
          <textarea className="input" style={{ minHeight: 160 }} placeholder={"best seo tools\nai writing software\nkeyword research\nbacklink checker\nsite audit tool"} value={keywords} onChange={e => setKeywords(e.target.value)} />
        </div>
        <button className="btn btn-orange" onClick={analyze} disabled={loading}>{loading ? 'Checking...' : `Check ${keywords.split('\n').filter(Boolean).length} keywords →`}</button>
        {error && <div style={{ marginTop: 10, color: '#FF3D57', fontSize: 13, background: '#FFEBEE', padding: '8px 12px', borderRadius: 6 }}>{error}</div>}
      </div>

      {loading && <div className="card"><div className="skeleton" style={{ height: 200 }} /></div>}

      {data && (
        <div className="card">
          <div className="card-header"><span className="card-title">{data.length} keywords analyzed</span><span className="badge badge-gray">{data.filter(k => k.kd < 30).length} easy</span></div>
          <div className="table-wrap">
            <table className="table">
              <thead><tr><th>Keyword</th><th>Volume</th><th>KD</th><th>Level</th><th>CPC</th><th>Intent</th></tr></thead>
              <tbody>
                {data.map((k,i) => (
                  <tr key={i}><td style={{ fontWeight: 600 }}>{k.keyword}</td><td>{k.volume.toLocaleString()}</td><td>{k.kd}%</td><td><span className={`badge ${k.kdLevel === 'Easy' ? 'badge-green' : k.kdLevel === 'Medium' ? 'badge-yellow' : 'badge-red'}`}>{k.kdLevel}</span></td><td>${k.cpc}</td><td><span className="badge badge-gray">{k.intent}</span></td></tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
